module.exports = __webpack_public_path__ + "img/eva_arrow-ios-forward-outline-left.7af8b7e1.svg";